module.exports = __webpack_public_path__ + "a6ccca26163edbe2c2d521a4b8426a4e.jpg";